import { render, staticRenderFns } from "./XmlCte.vue?vue&type=template&id=b3a7c6e2"
import script from "./XmlCte.vue?vue&type=script&lang=js"
export * from "./XmlCte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports